import dynamic from "next/dynamic"

// The tool-call readout is rendered by the eager overlay shell but must not
// ship in its chunk: it statically imports the Mindtrip-only playground card
// (voice-tool-call-card.tsx), which nothing else pulls in eagerly. Same
// isolated-module pattern as lazy-voice-chat-content.tsx, and for the same
// reason — tests mock this boundary to the eager component.
export const LazyVoiceChatToolCalls = dynamic(
  () =>
    import("./voice-chat-tool-calls").then((mod) => ({
      default: mod.VoiceChatToolCalls,
    })),
  { ssr: false }
)
